import React, { useState } from "react";
import { Helmet } from "react-helmet";
import ListFormTemplate from "../../PageTemplate/ListFormTemplate";
import { config } from "../../../utils/config";
import { fetchDataAndMapToField } from "../../../utils/helperFuctions";
import useCurrencyExchangeLogic from "./useCurrencyExchangeLogic";

const columns = [
  //{ field: 'id', label: 'ID', allowSorting: false },
  {
    field: "primary_currency",
    label: "Primary Currency",
    allowSorting: true,
    subvalue: "code",
  },
  {
    field: "secondary_currency",
    label: "Secondary Currency",
    allowSorting: true,
    subvalue: "code",
  },
  { field: "rate_multiply", label: "Rate Multiply", allowSorting: false },
  { field: "valid_from", label: "Valid From", allowSorting: false },
  { field: "expiry_date", label: "Expiry", allowSorting: false },
];

const CurrencyExchangePage = () => {
  const { addRoles, deleteRoles, editRoles, apiRoute, initFields } =
    useCurrencyExchangeLogic();
  const [fields, setfields] = useState(initFields);

  const loadOptions = async (branchId) => {
    try {
      const temp = [...initFields];
      //API endpoint to fetch the data
      // Call the function for each API endpoint
      const promises = [
        fetchDataAndMapToField(
          config,
          "currencies",
          "primary_currency",
          temp,
          "code",
          "symbol"
        ),
        fetchDataAndMapToField(
          config,
          "currencies",
          "secondary_currency",
          temp,
          "code",
          "symbol"
        ),
      ];

      // Wait for all promises to resolve
      await Promise.all(promises);

      setfields(temp);
    } catch (error) {
      console.error("Error fetching data:", error);
      return [];
    }
  };

  return (
    <div>
      <Helmet>
        <title>Admin | Glide</title>
        <meta name="description" content="Welcome to the Currency Exchange." />
        {/* Other meta tags */}
      </Helmet>
      <ListFormTemplate
        // this one is used to fetch filter options , so i can do a single backend function to fetch for all pages
        tableNameInDb="currency_exchange"
        //
        apiRoute={apiRoute}
        columns={columns}
        fields={fields}
        bringFormData={loadOptions}
        createRoles={addRoles}
        deleteRoles={deleteRoles}
        editRoles={editRoles}
        enhancedTable={true}
      />
    </div>
  );
};

export default CurrencyExchangePage;
